import { Icon } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';

import Add from './Add';
import ListEmergencyContacts from './List';

export default function IndexEmergencyContacts() {
  const [openEmergencyContact, setOpenEmergencyContact] = useState(false);

  return (
    <>
      <List>
        <ListItem
          button
          onClick={() => {
            setOpenEmergencyContact(!openEmergencyContact);
          }}>
          <ListItemIcon>
            <Icon className="icon-phone" />
          </ListItemIcon>
          <ListItemText primary="Acil Durumda Aranacaklar" />
          {openEmergencyContact ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openEmergencyContact} timeout="auto" unmountOnExit>
          <Add />
          <ListEmergencyContacts />
        </Collapse>
      </List>
    </>
  );
}
